import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCTAClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div 
        className="hero-background"
        style={{
          transform: `translateY(${scrollY * 0.5}px)`
        }}
      />
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className="hero-stars">
          <Sparkles className="floating-star star-1" size={24} />
          <Sparkles className="floating-star star-2" size={32} />
          <Sparkles className="floating-star star-3" size={20} />
        </div>
        <h1 className="hero-title fade-in-up">
          Illuminate Your Path <br /> Through the Stars
        </h1>
        <p className="hero-subtitle fade-in-up delay-1">
          Where Ancient Wisdom Meets Modern Insight
        </p>
        <div className="hero-metaphor fade-in-up delay-2">
          <em>
            Just as the North Star has guided travelers for millennia,<br />
            AstroClick illuminates your life's journey with precision, wisdom, and unwavering clarity.
          </em>
        </div>
        <Button 
          className="hero-cta fade-in-up delay-3"
          onClick={handleCTAClick}
        >
          Book Now
        </Button>
      </div>
    </section>
  );
};

export default HeroSection;